import React from "react";

export default function NewsBlog() {
  return <div>News</div>;
}
